export const qr = {
  seo: {
    title: 'QR ordering on-site for restaurants | Bistroo',
    description: 'Let guests order and pay independently via QR code. Less staff needed, higher order value. Try free for 30 days.',
  },
  hero: {
    title: {
      pt1: 'A',
      pt2: 'QR solution',
      pt3: 'tailor-made for your restaurant',
    },
    description:
      'Enable a cost-saving table ordering process, take the pressure off your staff and improve your customer experience from the first scan to payment.',
    button: 'Discover the QR solution',
  },
  paragraphs: {
    paragraph_1: {
      title: 'Simplify ordering, maximize customer satisfaction',
      text: 'Give your customers the freedom to order what and when they want. Optimize service, increase convenience and improve the customer experience with every scan.',
      cta: 'Explore the Bistroo packages',
    },
    paragraph_2: {
      title: 'Update your QR shop easily',
      text: 'All updates in the Bistroo Manager are instantly synced to the QR stickers on your tables, making menu changes faster and easier than ever.',
      cta: '',
    },
    paragraph_3: {
      title: 'Your style, your stickers',
      text: 'The stickers are high quality and custom-made in your style and branding. They are made from durable and weather-resistant material, making them suitable for both indoor and outdoor use.',
      cta: 'Explore the Bistroo packages',
    },
    paragraph_4: {
      title: 'Easy administration',
      text: 'From payments to invoices, everything is fully automated. Orders are processed, payments can be tracked and invoices are automatically generated, drastically reducing your workload.',
      cta: '',
    },
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Make upselling part of your business.',
        text: 'Use the smart upsell options and make them a natural part of every on-site order, growing revenue effortlessly.',
        button: '',
        img_alt: '',
      },
      card_2: {
        title: 'Integrations.',
        text: 'Connect your favorite POS system or external tools.',
        button: '',
        img_alt: '',
      },
      card_3: {
        title: 'Solve staffing challenges.',
        text: 'When a staffing challenge arises, you can easily handle it with QR table ordering.',
        button: '',
        img_alt: '',
      },
      card_4: {
        title: 'Instant payments.',
        text: 'No more paying at the counter — customers pay while ordering.',
        button: '',
        img_alt: '',
      },
      card_5: {
        title: 'Discounts and loyalty.',
        text: 'Encourage customers to use the QR solution by making use of our discount and loyalty options.',
        button: '',
        img_alt: '',
      },
    },
  },
  testimonial: {
    text: '"A great collaboration and a partner that is there for you 24/7."',
    cta: 'Read the full story',
    name: 'De Wethouder',
    job_title: 'Sushi & Drink Club',
  },
  faq: {
    title_pt1: 'All about the',
    title_pt2: 'Bistroo QR solution',
    items: [
      { q: 'How does QR ordering work for my guests?', a: 'Guests scan the QR sticker on the table with their phone, immediately see the menu and order and pay independently. No app needed, no waiting at the counter.' },
      { q: 'How do I create QR stickers?', a: 'After activating the QR module in your Bistroo account, you generate custom stickers in your own style and branding. Bistroo prints them for you on durable, weather-resistant material.' },
      { q: 'Can guests pay directly via the QR code?', a: 'Yes. Guests pay directly when ordering via iDEAL, credit card, Apple Pay or Google Pay. No more paying at the counter and no waiting for the bill.' },
      { q: 'Is the menu automatically synchronized?', a: 'Yes. All changes you make in the Bistroo Manager are immediately visible in the QR shop. You never have to update your menu in two places.' },
      { q: 'How are QR orders processed in the kitchen?', a: 'QR orders come in the same way as all other Bistroo orders: directly to the Bistroo Device, kitchen printer or POS system. No extra screen or action needed.' },
      { q: 'Are the QR stickers suitable for outdoor use?', a: 'Yes. The stickers are made from weather-resistant material and are suitable for both indoor and outdoor use, including terraces in rain or sunshine.' },
      { q: 'Can I create separate QR codes per table or zone?', a: 'Yes. You create separate QR codes per table, per room or per terrace. This way your kitchen always knows exactly which table an order came from.' },
      { q: 'How do I set up upselling for QR orders?', a: 'Via the Bistroo Manager you activate automatic upsell suggestions. During ordering, the guest is shown relevant extras or combinations, which increases the average order value.' },
      { q: 'What does the QR solution cost?', a: 'The QR module is part of the Bistroo packages. Depending on your package there are no or minimal extra costs. Check the pricing page for the current overview.' },
      { q: 'How do I receive notifications for new QR orders?', a: 'New orders appear immediately on the Bistroo Device, the Manager app and any connected printers. You also receive a push notification on the Bistroo app so you never miss an order.' },
    ],
  },
}
